/* eslint-disable */
import React from 'react';
import { Mail, Phone, Clock, Briefcase } from 'lucide-react';
import LegalPage from '../components/LegalPage';

const ContactUs = () => (
  <LegalPage eyebrow="WE'RE LISTENING" title="Contact" italicTail="the maison.">
    <p>Velouva Cosmetics is here to help — with orders, shades, returns, or simply to share a thought.</p>

    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 not-prose">
      <a href="mailto:service@velouva.in" className="block border border-[#cdc2b1] p-6 hover:border-[#1a1410] transition-colors">
        <div className="flex items-center gap-3 text-[11px] tracking-[0.22em] text-[#7a6a5a]">
          <Mail className="w-4 h-4" strokeWidth={1.4} /> EMAIL
        </div>
        <div className="font-serif text-xl mt-3">service@velouva.in</div>
      </a>
      <a href="tel:+917875779190" className="block border border-[#cdc2b1] p-6 hover:border-[#1a1410] transition-colors">
        <div className="flex items-center gap-3 text-[11px] tracking-[0.22em] text-[#7a6a5a]">
          <Phone className="w-4 h-4" strokeWidth={1.4} /> PHONE
        </div>
        <div className="font-serif text-xl mt-3">+91 78757 79190</div>
      </a>
      <div className="border border-[#cdc2b1] p-6">
        <div className="flex items-center gap-3 text-[11px] tracking-[0.22em] text-[#7a6a5a]">
          <Clock className="w-4 h-4" strokeWidth={1.4} /> CUSTOMER SUPPORT HOURS
        </div>
        <div className="font-serif text-lg mt-3">Monday — Saturday</div>
        <div className="text-sm text-[#3a2e26] mt-1">10:00 AM — 6:00 PM IST</div>
      </div>
      <div className="border border-[#cdc2b1] p-6">
        <div className="flex items-center gap-3 text-[11px] tracking-[0.22em] text-[#7a6a5a]">
          <Briefcase className="w-4 h-4" strokeWidth={1.4} /> BUSINESS ENQUIRIES
        </div>
        <div className="text-sm text-[#3a2e26] mt-3 leading-relaxed">
          Partnerships, influencer collaborations, wholesale enquiries, and distribution opportunities.
        </div>
        <a href="mailto:service@velouva.in" className="mt-3 inline-block text-[11px] tracking-[0.28em] border-b border-[#1a1410] pb-0.5">
          SERVICE@VELOUVA.IN
        </a>
      </div>
    </div>
  </LegalPage>
);

export default ContactUs;
